// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Row$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as TicketLeftSection from "./TicketLeftSection.bs.js";
import * as TicketRightSection from "./TicketRightSection.bs.js";
import * as LoaderComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/loader/LoaderComponent.bs.js";
import * as TicketDashboardRepoManager from "../../../app/tickets/repo/TicketDashboardRepoManager.bs.js";
import * as TicketDashboardAssetsManager from "../../assets/TicketDashboardAssetsManager.bs.js";

TicketDashboardAssetsManager.importCss(undefined);

var LoaderConfig = {};

var LoaderComponent = LoaderComponent$Catalyst.LoaderComponentWithoutRefresh(LoaderConfig);

function TicketContainer$TicketComponent(Props) {
  var ticket = Props.ticket;
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: "c-ticket-details-page"
            }, React.createElement(TicketLeftSection.make, {
                  ticket: ticket
                }), React.createElement(TicketRightSection.make, {
                  ticket: ticket
                }));
}

var TicketComponent = {
  make: TicketContainer$TicketComponent
};

function TicketContainer(Props) {
  var case_number = Props.case_number;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  return React.createElement(LoaderComponent.make, {
              fetchData: (function (param) {
                  var RepoInstance = TicketDashboardRepoManager.getTicketsRepo(undefined);
                  return Curry._2(RepoInstance.fetchTicket, case_number, country);
                }),
              renderView: (function (ticket) {
                  return React.createElement(TicketContainer$TicketComponent, {
                              ticket: ticket
                            });
                })
            });
}

var make = TicketContainer;

export {
  LoaderConfig ,
  LoaderComponent ,
  TicketComponent ,
  make ,
  
}
/*  Not a pure module */
